<template>
  <div class="header">
    <v-container>
      <v-toolbar
        class="toolbar"
        name="toolbar"
        flat
        height="84px"
      >
        <router-link :to="{ name: 'home'}">
          <v-img
            class="logo-img"
            :src="$t('header.img.logo.img')"
          />
        </router-link>
        <v-spacer />
        <div class="d-none d-lg-flex">
          <v-toolbar-items class="toolbar_menu">
            <template v-for="item in navLinks">
              <span
                v-if="item.to"
                :key="item.id"
                class="item"
              >
                <router-link
                  :to="item.to"
                >
                  {{ item.title }}
                </router-link>
              </span>
              <span
                v-else
                :key="item.id"
                class="item"
                v-html="item.title"
              />
            </template>
          </v-toolbar-items>
          <v-menu
            v-model="showAccountMenu"
            offset-y
            close-on-click
            close-on-content-click
          >
            <template v-slot:activator="{ on, attrs }">
              <section
                class="toolbar_account"
                v-bind="{attrs}"
                v-on="on"
              >
                <div class="name">
                  <!-- <router-link :to="{ name: 'payment_information'}"> -->
                  <a class="name-primary">
                    {{ userName }}
                  </a>
                  <!-- </router-link> -->
                  <span class="name-secondary">
                    {{ companyName }}
                  </span>
                </div>
                <!-- <router-link :to="{ name: 'payment_information'}"> -->
                <v-icon
                  class="avatar"
                  color="primary"
                  size="38"
                >
                  mdi-account-circle
                </v-icon>
                <!-- </router-link> -->
              </section>
            </template>
            <v-list>
              <v-list-item
                @click="handleMenuClick('payment_information')"
              >
                <v-list-item-title>{{ $t('header.txt.my_account') }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="handleMenuClick('payment_method')"
              >
                <v-list-item-title>{{ $t('header.txt.payment_method') }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
        <v-divider
          class="d-none d-lg-inline-block mx-4 my-0 align-self-center"
          inset
          vertical
        />
        <v-select
          v-model="locale"
          class="change-lang"
          background-color="pale-three"
          color="slate"
          :append-icon="'mdi-chevron-down'"
          :items="locales"
          :menu-props="{ offsetY: true }"
          dense
          filled
          rounded
          return-object
          @change="switchLocale"
        />
        <v-divider
          class="mx-4 my-0 align-self-center"
          inset
          vertical
        />
        <div
          v-if="totalItems>0"
          class="toolbar_basket"
          @click.stop="drawerCheckout = !drawerCheckout; openDrawer()"
        >
          <v-badge
            class="basket-badge"
            color="white"
            overlap
            bordered
            :content="totalItems"
            :value="totalItems"
          >
            <img
              :src="$t('header.img.basket.img')"
              class="basket-icon"
            >
          </v-badge>
        </div>
        <div
          v-if="totalItems<=0"
          class="toolbar_basket"
        >
          <v-badge
            class="basket-badge"
            color="white"
            overlap
            bordered
            :content="totalItems"
            :value="totalItems"
          >
            <img
              :src="$t('header.img.basket.disabled')"
              class="basket-icon"
            >
          </v-badge>
        </div>
        <v-divider
          class="d-lg-none ml-4 my-0 align-self-center"
          inset
          vertical
        />
        <v-app-bar-nav-icon
          class="d-block d-lg-none"
          @click.stop="drawerMenu = !drawerMenu"
        />
      </v-toolbar>
    </v-container>
    <v-navigation-drawer
      v-model="drawerMenu"
      fixed
      temporary
      right
      class="drawer"
    >
      <v-list-item class="drawer_account">
        <router-link :to="{ name: 'payment_information'}">
          <v-icon
            class="HeaderAccount_avatar"
            color="primary"
            size="24"
          >
            mdi-account-circle
          </v-icon>
        </router-link>
        <div class="name">
          <router-link :to="{ name: 'payment_information'}">
            <span class="name-primary">
              {{ userName }}
            </span>
          </router-link>
          <span class="name-secundary">
            {{ companyName }}
          </span>
        </div>
      </v-list-item>

      <v-divider />
      <v-list
        dense
        class="drawer_menu"
      >
        <v-list-item
          v-for="item in mobileNavLinks"
          :key="item.id"
          link
        >
          <v-list-item-content
            v-if="item.to"
          >
            <router-link
              :to="item.to"
              class="item"
            >
              {{ item.title }}
            </router-link>
          </v-list-item-content>
          <v-list-item-content
            v-else
            v-html="item.title"
          />
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-navigation-drawer
      v-if="drawerCheckout"
      v-model="drawerCheckout"
      fixed
      temporary
      right
      width="auto"
      class="checkout"
    >
      <AppCheckout
        :key="checkoutkey"
        @close-drawer="closeDrawer"
      />
    </v-navigation-drawer>
  </div>
</template>

<script>
import AppCheckout from '@/components/AppCheckout.vue'
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  name: 'AppHeader',
  components: {
    AppCheckout
  },
  data() {
    return {
      drawerMenu: null,
      drawerCheckout: false,
      checkout: [],
      totalCheckout: 0,
      checkoutkey: 0,
      items: [],
      userName: '',
      companyName: '',
      showAccountMenu: false,
      locale: this.$i18n.locale
    }
  },
  computed: {
    ...mapState('checkout', {
      totalItems: state => state.totalCheckout
    }),
    ...mapState('account', ['currency', 'accountDetails', 'payload']),
    navLinks() {
      return [
        {
          id: 'information',
          to: null,
          title: this.$t('header.txt.information')
        },
        {
          id: 'my-invoices',
          to: { name: 'invoices' },
          title: this.$t('header.txt.my_invoices')
        }
      ]
    },
    mobileNavLinks() {
      return [
        {
          id: 'information',
          to: null,
          title: this.$t('header.txt.information')
        },
        {
          id: 'my-invoices',
          to: { name: 'invoices' },
          title: this.$t('header.txt.my_invoices')
        },
        {
          id: 'payment_information',
          to: { name: 'payment_information' },
          title: this.$t('header.txt.my_account')
        },
        {
          id: 'payment_method',
          to: { name: 'payment_method' },
          title: this.$t('header.txt.payment_method')
        }
      ]
    },
    ...mapState('locale', ['locales'])
  },

  async created() {
    // Carregar apenas se não existirem no store (evita chamadas redundantes após login)
    if (!this.$store.state.account.detailsLoaded ||
        !this.$store.state.account.accountInformation ||
        Object.keys(this.$store.state.account.accountInformation).length === 0) {
      await this.getAccountDetails()
    }

    // Currency só precisa ser carregado se não existir
    if (!this.currency || Object.keys(this.currency).length === 0) {
      await this.getCurrencyInfo()
    }

    // Checkout só precisa ser carregado se não existir no store
    if (!this.$store.state.checkout.checkout || this.$store.state.checkout.checkout.length === 0) {
      await this.getCheckout()
    }

    // Catálogo Service/DataService: já vem do login; se a sessão abriu sem /login (ex.: refresh), carregar uma vez.
    if (!this.$store.state.products.servicesLoaded) {
      await this.$store.dispatch('products/getServicesProducts')
    }

    await this.setTotalItemsCheckout()
    await this.getPayload(localStorage.getItem('userToken'))
    await this.setUserInformation()
  },
  methods: {
    ...mapMutations('checkout', ['setTotalItemsCheckout']),
    ...mapActions('checkout', ['getCheckout']),
    ...mapActions('account', [
      'getAccountDetails',
      'getCurrencyInfo',
      'getPayload'
    ]),
    switchLocale() {
      localStorage.setItem('locale', this.locale)
      location.reload()
    },
    closeDrawer() {
      this.drawerCheckout = false
    },
    openDrawer() {
      this.checkoutkey = Math.random()
    },
    setUserInformation() {
      this.userName = this.payload.Username
      this.companyName = this.accountDetails.companyName
    },
    handleMenuClick(viewName) {
      this.$router.push({
        name: viewName
      })
    }
  }
}
</script>

<style lang="scss">
.header {
  .toolbar {
    background-color: var(--v-pale-base) !important;
    border-bottom: 1px solid var(--v-bluegrey-light-base) !important;
    hr {
      height: 24px;
    }
    &_menu {
      align-items: center;
      .item {
        margin-right: 33px;
        font-size: 0.75rem;
        font-weight: bold;
        color: var(--v-peacock-base) !important;
        text-transform: uppercase;
      }

      a {
        text-decoration: none;
      }
    }
    &_account {
      display: flex;
      align-items: flex-end;
      .name {
        display: flex;
        flex-direction: column;
        text-align: right;
        font-style: italic;
        font-size: 0.75rem;
        margin-right: 16px;
        padding: 2px 0;
        &-primary {
          font-weight: bold;
          color: var(--v-peacock-base);
          text-decoration: underline;
        }
        &-secondary {
          color: var(--v-dark-base);
        }
      }
      .avatar {
        align-self: center;
        text-decoration: none;
      }
      a {
        text-decoration: none;
      }
    }
    &_basket {
      cursor: pointer;
      .basket-badge {
        .basket-icon {
          width: 32px;
          height: 24px;
        }
        .v-badge__badge {
          color: var(--v-dark-base) !important;
          &::after {
            border-color: var(--v-bluegrey-base) !important;
          }
        }
      }
    }
    &_items {
      padding: 0;
    }
    .change-lang {
      max-width: 120px;
      height: 32px;
      font-size: 0.875rem;

      .v-input {
        &__slot {
          min-height: 32px !important;
        }

        &__append-inner {
          margin-top: 0 !important;
        }
      }
    }
    .logo-img {
      width: 141px;
      height: 48px;
    }
  }
  .drawer {
    &_menu {
      align-items: center;
      a {
        font-size: 0.75rem;
        font-weight: bold;
        color: var(--v-peacock-base) !important;
        text-transform: uppercase;
        text-decoration: none;
      }
    }
    &_account {
      display: flex;
      .name {
        display: flex;
        flex-direction: column;
        font-style: italic;
        font-size: 0.75rem;
        margin-left: 10px;
        padding: 2px 0;
        &-primary {
          font-weight: bold;
          color: var(--v-peacock-base);
          text-decoration: underline;
        }
        &-secondary {
          color: var(--v-dark-base);
        }
      }
    }
  }
  .checkout {
    max-width: 720px;
    min-width: 720px;
  }
}
</style>